import React from "react";




export default function ItemsMoreMenu({handleIrVariz,handleIrBardasht,varizchange,bardashtchange,coinchange, coinbchange}){
  const NavItems = [
    {
      title: 'واریز تومان',

      icon: <img className="img-icon-34" src={'icons/mobile/deposit2.svg'} alt=""/>
,

      onclick: handleIrVariz

    },

    {
      title: 'برداشت تومان',

      icon: <img className="img-icon-34" src={'icons/mobile/wid2.svg'} alt=""/>

,


    onclick: handleIrBardasht


    },

    {
      title: ' واریز ارز',

      icon: <img className="img-icon-34" src={'icons/mobile/deposit2.svg'} alt=""/>
,


    onclick: ''


    },

    {
      title: ' برداشت ارز',

      icon: <img className="img-icon-34" src={'icons/mobile/wid2.svg'} alt=""/>
,

      onclick: ''
,

    }
  ]




  function handleCoinV(event) {
    coinchange('USDT')
     varizchange(true)
 }

 function handleCoinB(event){
    coinbchange('USDT')
    bardashtchange(true)
 }




    return(
        <>



<div className="items-more">


{NavItems.map((item,index)=>



    index>1?

        index === 2 ?

            <div key={index} data-key={index} className="nav-item-content" onClick={handleCoinV}>

                {item.icon}

                <p className="nav-item-title34">
                    {item.title}
                </p>


            </div>

            :

                            <div key={index} data-key={index} className="nav-item-content" onClick={handleCoinB}>

                {item.icon}

                <p className="nav-item-title34">
                    {item.title}
                </p>


            </div>









        :


                    <div key={index}  className="nav-item-content" onClick={item.onclick}>

    {item.icon}

    <p className="nav-item-title34">
        {item.title}
    </p>



</div>







)

}



</div>





        </>
    )
}